import Aos from "aos";
import "aos/dist/aos";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./ExploreFeature.css";
const ExploreFeature = () => {
  const [feature, SetFeature] = useState([]);

  useEffect(() => {
    fetch("/feature.json")
      .then((res) => res.json())
      .then((data) => SetFeature(data));
  }, []);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <Container id="HomeFeatures" className="overflow-hidden">
      <div className="second-heading text-center">
        <h2>Explore Smart Watch</h2>
        <h3>
          BUILT-IN APPS IN YOUR
          <span>WATCH</span>
        </h3>
      </div>
      <Row>
        {feature.map((featureItem) => (
          <Col md={4} sm={12} xm={12}>
            <Row className="feature-container align-items-center  my-5">
              <Col md={12}>
                <div className="featureImg text-center my-3">
                  <img data-aos="fade-down" src={featureItem.img} alt="" />
                </div>
              </Col>
              <Col md={12}>
                <div className="feature-details my-3">
                  <h4>{featureItem.type}</h4>
                  <h5>{featureItem.detail}</h5>
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ExploreFeature;
